import { DirectoryScreen } from '@/components/seo/directory-screen';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

/** `/profissionais/[categoria]`: diretório da categoria no Brasil todo. */
export default function CategoryDirectoryRoute() {
  const { categoria } = useLocalSearchParams<{ categoria: string }>();
  return <DirectoryScreen categorySlug={String(categoria ?? '')} />;
}
